import api from '@/api'

const SET_RECIPES = 'SET_RECIPES'

const SET_RECIPES_LIST = 'SET_RECIPES_LIST'

const SET_CURRENT_RECIPE = 'SET_CURRENT_RECIPE'
const UNSET_CURRENT_RECIPE = 'UNSET_CURRENT_RECIPE'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      recipes: [],
      recipesList: [],
      currentRecipe: null
    }
  },

  getters: {
    recipes: (state) => state.recipes,
    recipesList: (state) => state.recipesList,
    currentRecipe: (state) => state.currentRecipe
  },

  mutations: {
    [SET_RECIPES] (state, data) {
      state.recipes = data
    },

    [SET_RECIPES_LIST] (state, data) {
      state.recipesList = data
    },

    [SET_CURRENT_RECIPE] (state, data) {
      state.currentRecipe = data
    },

    [UNSET_CURRENT_RECIPE] (state) {
      state.currentRecipe = null
    }
  },

  actions: {
    async loadRecipes ({ commit }, params = {}) {
      const filters = { farm: params.farm }
      const { data } = await api.recipes.list(filters)
      commit(SET_RECIPES, data || [])
    },

    async loadRecipesList ({ commit }, params = {}) {
      const filters = { farm: params.farm }
      const { data } = await api.recipes.litelist(filters)
      commit(SET_RECIPES_LIST, data || [])
    },

    async createRecipe ({ dispatch }, payload) {
      const response = await api.recipes.create(payload)
      const filters = { farm: payload.farm }
      dispatch('loadRecipes', filters)
      return response
    },

    async selectRecipe ({ commit }, id) {
      const { data } = await api.recipes.getById(id)
      commit(SET_CURRENT_RECIPE, data)
      return data
    },

    async getRecipe ({ commit }, id) {
      const { data } = await api.recipes.getById(id)
      return data
    },

    async saveRecipe ({ commit }, payload) {
      await api.recipes.updateById(payload.id, payload)
      commit(UNSET_CURRENT_RECIPE)
    },

    closeRecipe ({ commit }) {
      commit(UNSET_CURRENT_RECIPE)
    }
  }
}
